import styles from './ListTable.module.scss';

type Props = {
    children: React.ReactNode;
    style?: React.CSSProperties;
};

const ListTable = ({ children, style }: Props) => {
    return (
        <div className={styles.root} style={style}>
            {children}
        </div>
    );
};

export { ListTable };
